"use client";
import {
  useMenuContext
} from "../__chunks/6UXSIZXV.js";
import "../__chunks/5FUUHUOH.js";
import "../__chunks/4LEWR5KQ.js";
import {
  useCompositeSeparator
} from "../__chunks/YI7PL2KY.js";
import "../__chunks/SXXKFAN5.js";
import "../__chunks/467XRHWL.js";
import "../__chunks/2LVHRIRC.js";
import "../__chunks/FYYAZUDI.js";
import "../__chunks/NO3UEYQ2.js";
import "../__chunks/SOQQIDO4.js";
import "../__chunks/CTVD4XJH.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/L4OUMOCQ.js";
import "../__chunks/W2TDKEPX.js";
import "../__chunks/AZVQSWGA.js";

// src/menu/menu-separator.tsx
var TagName = "hr";
var useMenuSeparator = createHook(
  function useMenuSeparator2({ store, ...props }) {
    const context = useMenuContext();
    store = store || context;
    props = useCompositeSeparator({ store, ...props });
    return props;
  }
);
var MenuSeparator = forwardRef(function MenuSeparator2(props) {
  const htmlProps = useMenuSeparator(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuSeparator,
  useMenuSeparator
};
